import React, { useMemo, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { showAppLoader, hideAppLoader } from 'redux/actions/app';
import Tooltip from "@material-ui/core/Tooltip";
import { KEY } from 'web/components/utils/stripeKey';

import {
  useStripe,
  useElements,
  CardNumberElement,
  CardCvcElement,
  CardExpiryElement,
} from '@stripe/react-stripe-js';


import Spinner from 'web/components/Spinner';
import AlertModal from 'web/components/AlertModal';
import { setupIntent } from 'redux/actions/register';
import styles from '../../corporate.module.scss';
import CvcIcon from 'web/assets/images/cvc.png';
import { CardTypeSectionStripe } from 'web/pages/account/registration/corporate-Registration-Styled';

const useOptions = () => {
  const fontSize = '16px';
  const options = useMemo(
    () => ({
      style: {
        base: {
          fontSize,
          color: '#424770',
          letterSpacing: '0.025em',
          fontFamily: 'Source Code Pro, monospace',
          '::placeholder': {
            color: '#aab7c4',
          },
        },
        invalid: {
          color: '#9e2146',
        },
      },
    }),
    [fontSize]
  );

  return options;
};

const DebitForm = ({ cardType, setFieldValue, accountType, stepSelected, props, id, pageLanguageContents, paymentFor }) => {
  const dispatch = useDispatch();
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [modalLink, setModalLink] = useState('');
  const [cardName, setCardName] = useState('');
  const toggleModal = () => setModal(!modal);
  let title = '';

  const [validateButtonEnable, setValidateButtonEnable] = useState(false)

  const loaderVisible = useSelector((state) => state.appReducer.loaderVisible);
  const stripe = useStripe();
  const elements = useElements();
  const options = useOptions();

  let cardBrandToPfClass = {
    visa: 'pf-visa',
    mastercard: 'pf-mastercard',
    amex: 'pf-american-express',
    discover: 'pf-discover',
    diners: 'pf-diners',
    jcb: 'pf-jcb',
    unknown: 'pf-credit-card',
  };

  const setBrandIcon = (brand) => {
    let brandIconElement = document.getElementById('brand-icon' + id);
    let pfClass = 'pf-credit-card';
    if (brand in cardBrandToPfClass) {
      pfClass = cardBrandToPfClass[brand];
    }
    for (let i = brandIconElement.classList.length - 1; i >= 0; i--) {
      brandIconElement.classList.remove(brandIconElement.classList[i]);
    }
    brandIconElement.classList.add('pf');
    brandIconElement.classList.add(pfClass);
  };

  useEffect(() => {
    let buyerOrSeller = props.values?.buyerSellerOption
    if (paymentFor === 'buying') {
      if (!props.values?.buyerPaymentValidated) setValidateButtonEnable(true)
      else setValidateButtonEnable(false)
    } else if (paymentFor === 'selling') {
      if ((props.values?.buyerPaymentValidated || buyerOrSeller === 'Seller') && !props.values?.sellerPaymentValidated) setValidateButtonEnable(true)
      else setValidateButtonEnable(false)
    } else if (paymentFor === 'subscription') {
      if (((buyerOrSeller === 'Buyer & Seller' || props.values.reseller === "active") && props.values?.buyerPaymentValidated && props.values?.sellerPaymentValidated && !props.values?.membershipPaymentValidated) ||
        (buyerOrSeller === 'Buyer' && props.values?.buyerPaymentValidated && !props.values?.membershipPaymentValidated) ||
        (buyerOrSeller === 'Seller' && props.values?.sellerPaymentValidated && !props.values?.membershipPaymentValidated)) {
        setValidateButtonEnable(true)
      } else setValidateButtonEnable(false)
    }
  }, [props])

  const debitCardSubmit = async () => {
    dispatch(showAppLoader())
    const card = elements.getElement(CardNumberElement);
    const result = await stripe.createToken(card, {
      currency: 'usd',
      name: cardName,
    }, stripeResponseHandler);
    if (result.token) {
      localStorage.setItem('cardType', result.token.card.funding);

      if (stepSelected === "debitCard" || stepSelected !== '') {
        if (result.token.card.funding === "debit") {
          setModalContent(pageLanguageContents?.Arrow2_Account[87]?.CardValidated)
          setModalLink('');
          toggleModal();

          if (paymentFor === 'buying') {
            setFieldValue('buyerPaymentValidated', true)
            localStorage.setItem('buyerDebitCardName', cardName);
            localStorage.setItem('buyerDebitCardNumber', result.token.card.last4);
            localStorage.setItem('buyerDebiCardPaymentMethod', result.token.id);
          } else if (paymentFor === 'selling') {
            setFieldValue('sellerPaymentValidated', true)
            localStorage.setItem('debiCardPaymentMethod', result.token.id);
            localStorage.setItem('sellerDebitCardName', cardName);
            localStorage.setItem('sellerDebitCardNumber', result.token.card.last4);
            localStorage.setItem('sellerDebiCardPaymentMethod', result.token.id);
          }
        } else {
          setModalContent(pageLanguageContents?.Arrow2_Account[88]?.DebitNotValidated)
          setModalLink('');
          toggleModal();
        }
      } else if (accountType === "creditCard") {
        if (result.token.card.funding === "debit") {
          setModalContent("Credit card details not validated.")
          setModalLink('');
          toggleModal();
        } else {

          if (paymentFor === 'buying') setFieldValue('buyerPaymentValidated', true)

          setModalContent(pageLanguageContents?.Arrow2_Account[87]?.CardValidated)
          setModalLink('');
          toggleModal();
          localStorage.setItem('creditCardName', cardName);
          localStorage.setItem('creditCardNumber', result.token.card.last4);
        }
      } else if (accountType === "paymentSubscription") {
        setModalContent(pageLanguageContents?.Arrow2_Account[87]?.CardValidated)
        setModalLink('');
        toggleModal();

        if (paymentFor === 'subscription') setFieldValue('membershipPaymentValidated', true)

        localStorage.setItem('subscriptionCardName', cardName);
        localStorage.setItem('subscriptionCardNumber', result.token.card.last4);

      }
      dispatch(hideAppLoader())
    } else {
      dispatch(hideAppLoader())
      setModalContent(result.error.message);
      setModalLink('');
      toggleModal();
    }
  }

  const storedGuestBasicInfo = localStorage.getItem('guestBasicInfo');
  const guestBasicInfo = (storedGuestBasicInfo && storedGuestBasicInfo !== '')
    ? JSON.parse(storedGuestBasicInfo)
    : {};

  const callSubmit = async () => {
    if (cardName.trim() !== '') {
      dispatch(showAppLoader())
      if (cardType === 'debitCard') {
        //Debit Card     
        debitCardSubmit()
      } else {
        let data = {
          email: props.values.email || localStorage.getItem('email') || guestBasicInfo?.email
        }
        const response = await dispatch(setupIntent(data));
        if (response.data.status === "SUCCESS") {
          //Credit Card
          let client_secret = response.data.payload
          const payload = await stripe
            .confirmCardSetup(client_secret, {
              payment_method: {
                card: elements.getElement(CardNumberElement),
                billing_details: {
                  name: cardName,
                },
              },
            })
            .then(function (result) {
              dispatch(hideAppLoader());
              if (result.error) {
                setModalContent(result.error.message);
                setModalLink('');
                toggleModal();
              } else {
                if (accountType === "creditCard") {
                  localStorage.setItem('credtCardPaymentMethod', result.setupIntent.payment_method);
                } else {
                  localStorage.setItem('paymentSubscription', result.setupIntent.payment_method);
                }
                debitCardSubmit()
              }
            });
        } else {
          setModalContent(response.data.message);
          setModalLink('');
          toggleModal();
        }
      }
    } else {
      setModalContent("Please enter name on the card first.");
      setModalLink('');
      toggleModal();
    }
  }

  // since all the steps are merged into 3 steps, validations of step 2 to 6 is done here
  const handleSubmit = async (event) => {
    event.preventDefault();

    step2checker()
    if (step2checker()) {
      step3checker()
    }
  };

  const step4checkerCall = () => {
    step4checker()

    if (step4checker()) {
      if (!stripe || !elements) {
        return;
      }
      if (!cardName) {
        setModalContent("Please enter name on the card first.");
        setModalLink('');
        toggleModal();
      } else {
        callSubmit()
      }

    }
  }
  const step2checker = () => {
    if (!props.values.buyerSellerOption && props.values.reseller === "deActive") {
      setModalContent('Please select an account type.');
      setModalLink('');
      toggleModal();
      return false
    } else return true
  }

  const step3checker = async () => {
    const { setFieldError } = props

    if (props.values.buyerSellerOption === 'Seller' || props.values.buyerSellerOption === 'Buyer & Seller' || props.values.reseller === "active") {
      let businessType = ''
      if (props.values.taxidLicense === '1' || props.values.taxidLicense === 1) {
        businessType = "individual"
      } else {
        businessType = "company"
      }
      if (props.values.taxidLicense === '1' || props.values.taxidLicense === 1) {
        if (props.values.dob === '') {
          if (pageLanguageContents) setFieldError('dob', pageLanguageContents?.Error_Validations[37]?.MinEighteenAge)
          else setFieldError('dob', "Age must be 18 or older")
        } else {

          // upload license
          dispatch(showAppLoader())
          const data = new FormData();
          data.append('file', props.values?.drivingLicenseDoc);
          data.append('purpose', 'identity_document');
          const fileResult = await fetch('https://uploads.stripe.com/v1/files', {
            method: 'POST',
            headers: { 'Authorization': `Bearer ${KEY}` },
            body: data,
          });
          const fileData = await fileResult.json();

          let dayMonthYear = props.values.dob.split('-')
          const result = await stripe.createToken('account', {
            business_type: businessType,
            individual: {
              first_name: props.values.firstName,
              last_name: props.values.lastName,
              address: {
                line1: `${props.values.line1 !== '' ? props.values.line1 : guestBasicInfo?.line1 ? guestBasicInfo?.line1 : ''} 
                        ${props.values.line2 !== '' ? props.values.line2 : guestBasicInfo?.line2 ? guestBasicInfo?.line2 : ''}`,
                city: props.values.locationCity !== '' ? props.values.locationCity :
                  guestBasicInfo?.city !== '' ? guestBasicInfo?.city : '',
                state: props.values.locationST !== '' ? props.values.locationST :
                  guestBasicInfo?.state !== '' ? guestBasicInfo?.state : '',
                postal_code: props.values.locationZip !== '' ? props.values.locationZip :
                  guestBasicInfo?.zip !== '' ? guestBasicInfo?.zip : '',
              },
              email: props.values.email !== '' ? props.values.email :
                guestBasicInfo?.email !== '' ? guestBasicInfo?.email : '',
              // phone: "+1." + props.values.smsPhNumber?.replace(/\D/g, ""),
              dob: {
                day: dayMonthYear[2],
                month: dayMonthYear[1],
                year: dayMonthYear[0]
              },
              ssn_last_4: '1234',//props.values.ssn,
              verification: {
                document: {
                  front: fileData.id
                },
              },
            },
            tos_shown_and_accepted: true,
          }).then(function (result) {
            dispatch(hideAppLoader())
            if (result.token) {
              step4checkerCall()
              localStorage.setItem('accountToken', result.token.id);
              return true
            }
            if (result.error) {
              if (result.error.message === "This value must be greater than or equal to 1900 (it currently is '1865').") {
                setModalContent("Users must be over 18 years of age. Please enter a valid date of birth.")
                setFieldError('dob', 'Users must be over 18 years of age. Please enter a valid date of birth.');
              } else if (result.error.message === "Must be at least 13 years of age to use Stripe") {
                setModalContent("Users must be over 18 years of age. Please enter a valid date of birth.")
                setFieldError('dob', 'Users must be over 18 years of age. Please enter a valid date of birth.');
              } else {
                setModalContent(result.error.message)
              }

              setModalLink('');
              toggleModal();
              return false
            }
          });
        }
      } else {
        const result = await stripe.createToken('account', {
          business_type: businessType,
          company: {
            tax_id: props.values.taxId,
            name: props.values.companyName !== '' ? props.values.companyName :
              guestBasicInfo?.companyName !== '' ? guestBasicInfo?.companyName : '',
            address: {
              line1: `${props.values.line1 !== '' ? props.values.line1 : guestBasicInfo?.line1 ? guestBasicInfo?.line1 : ''} 
                      ${props.values.line2 !== '' ? props.values.line2 : guestBasicInfo?.line2 ? guestBasicInfo?.line2 : ''}`,
              city: props.values.locationCity !== '' ? props.values.locationCity :
                guestBasicInfo?.city !== '' ? guestBasicInfo?.city : '',
              state: props.values.locationST !== '' ? props.values.locationST :
                guestBasicInfo?.state !== '' ? guestBasicInfo?.state : '',
              postal_code: props.values.locationZip !== '' ? props.values.locationZip :
                guestBasicInfo?.zip !== '' ? guestBasicInfo?.zip : '',
            },
            // phone: "+1." + props.values.smsPhNumber?.replace(/\D/g, ""),
          },
          tos_shown_and_accepted: true,
        }).then(function (result) {
          if (result.token) {
            step4checkerCall()
            localStorage.setItem('accountToken', result.token.id);
            return true
          }
          if (result.error) {
            if (result.error.message === "This value must be greater than or equal to 1900 (it currently is '1865').") {
              setModalContent("Users must be over 18 years of age. Please enter a valid date of birth.")
              setFieldError('dob', 'Users must be over 18 years of age. Please enter a valid date of birth.');
            } else if (result.error.message === "Must be at least 13 years of age to use Stripe") {
              setModalContent("Users must be over 18 years of age. Please enter a valid date of birth.")
              setFieldError('dob', 'Users must be over 18 years of age. Please enter a valid date of birth.');
            } else {
              setModalContent(result.error.message)
            }
            setModalLink('');
            toggleModal();
            return false
          }
        });
      }
    } else {
      const result = await stripe.createToken('account', {
        company: {
          tax_id: props.values.taxId,
        },
        tos_shown_and_accepted: true,
      }).then(function (result) {
        if (result.token) {
          step4checkerCall()
          localStorage.setItem('accountToken', result.token.id);
          return true
        }
        if (result.error) {
          if (result.error.message === "This value must be greater than or equal to 1900 (it currently is '1865').") {
            setModalContent("Users must be over 18 years of age. Please enter a valid date of birth.")
            setFieldError('dob', 'Users must be over 18 years of age. Please enter a valid date of birth.');
          } else if (result.error.message === "Must be at least 13 years of age to use Stripe") {
            setModalContent("Users must be over 18 years of age. Please enter a valid date of birth.")
            setFieldError('dob', 'Users must be over 18 years of age. Please enter a valid date of birth.');
          } else {
            setModalContent(result.error.message)
          }
          setModalLink('');
          toggleModal();
          return false
        }
      });
    }

  }

  const step4checker = async () => {
    if (props.values.accountHolderName === '0') {
      if (props.values.accountHolderName !== '' && props.values.bankRouting !== '' && props.values.bankAccount !== '') {
        dispatch(showAppLoader())
        let bankAccountParams = {
          country: 'US',
          currency: 'usd',
          account_holder_name: props.values.accountHolderName,
          account_holder_type: 'individual',
          routing_number: props.values.bankRouting,
          account_number: props.values.bankAccount,
        };
        const result = await stripe.createToken('bank_account', bankAccountParams);
        if (result.error) {
          dispatch(hideAppLoader())
          setModalContent(result.error.message);
          setModalLink('');
          toggleModal();
        } else {
          return true
          dispatch(hideAppLoader())
          localStorage.setItem('debiCardPaymentMethod', result.token.id);
        }
      }
    } else {
      return true
    }
  };

  const stripeResponseHandler = (status, response) => {
  }
  const handleChange = (event) => {
    const setValue = event.target.value.replace(/[^a-zA-Z0-9&.'\s]/g, '');
    setCardName(setValue);
  }

  const cardInputFields = (item, index) => {
    return (
      <CardTypeSectionStripe>
        <form onSubmit={handleSubmit} key={index}>
          <label>
            {pageLanguageContents?.Arrow2_Account[45]?.CardName}
            <input
              name="cardName"
              className="stripeInput"
              placeholder={pageLanguageContents?.Arrow2_Account[46]?.CardName_Placeholder}
              value={cardName}
              onChange={(event) => {
                handleChange(event);
              }}
            />
          </label>
          <label>
            {pageLanguageContents?.Arrow2_Account[47]?.CardNumber}
            <CardNumberElement
              id={`${paymentFor}${cardType}Card`}
              options={options}
              onReady={() => { }}
              onChange={(event) => {
                // Switch brand logo
                if (event.brand) {
                  setBrandIcon(event.brand);
                }
              }}
              onBlur={() => { }}
              onFocus={() => { }}
            />
            <span class="brand">
              <i id={"brand-icon" + id}></i>
            </span>
          </label>

          <label>
            {pageLanguageContents?.Arrow2_Account[49]?.CardDate}
            <CardExpiryElement
              id={`${paymentFor}${cardType}Expiry`}
              options={options}
              onReady={() => { }}
              onChange={(event) => { }}
              onBlur={() => { }}
              onFocus={() => { }}
            />
          </label>
          <label>
            {pageLanguageContents?.Arrow2_Account[51]?.CardCVV}
            <CardCvcElement
              id={`${paymentFor}${cardType}Cvv`}
              options={options}
              onReady={() => { }}
              onChange={(event) => { }}
              onBlur={() => { }}
              onFocus={() => { }}
            />
            <Tooltip
              placement="top"
              arrow
              title={<img src={CvcIcon} />}
              enterTouchDelay={0}
            >
              <span className="i-icon">i</span>
            </Tooltip>
          </label>
          <div className={styles.footer}>
            <div className={styles.fieldGroup}>
              <div>
                <button
                  type="submit"
                  className={validateButtonEnable ? "app-green-button" : "app-greyDisabled-button"}
                  disabled={!validateButtonEnable}
                >
                  {pageLanguageContents?.Arrow2_Account[53]?.SellerValid}
                </button>
              </div>
            </div>
          </div>
        </form>
      </CardTypeSectionStripe>
    );
  }
  return (
    <div className='paymentWrapper '>
      {loaderVisible && <Spinner />}
      <div className='payment'>
        <div>
          {cardInputFields()}
          <AlertModal
            isOpen={modal}
            toggle={toggleModal}
            title={title}
            content={modalContent}
            link={modalLink}
          />
        </div>
      </div>
    </div>
  );
};

export default DebitForm;
